import { ConfigData } from "@happy-legal/graphql-types";
import { graphQlClient } from "../clients";
import { MUTATION_SET_CONFIG_DATA } from "../gql/mutations";
import {
  QUERY_GET_PRIVATE_CONFIG_DATA,
  QUERY_GET_PUBLIC_CONFIG_DATA,
} from "../gql/queries";
import { configDataInitState } from "../providers/ConfigDataProvider";
import { handleCatchReducer } from "./handleCatchReducer";

export const GET_CONFIG_DATA = "GET_CONFIG_DATA";
type TGET_CONFIG_DATA = {
  type: "GET_CONFIG_DATA";
  id: string;
  private?: boolean;
};

export const SET_CONFIG_DATA = "SET_CONFIG_DATA";
type TSET_CONFIG_DATA = {
  type: "SET_CONFIG_DATA";
  payload: ConfigData;
};

export type TConfigDataAction = TGET_CONFIG_DATA | TSET_CONFIG_DATA;

export const configDataReducer = async (
  state: ConfigData,
  action: TConfigDataAction
) => {
  try {
    switch (action.type) {
      case GET_CONFIG_DATA: {
        // Set either private or public configs
        const query = action.private
          ? QUERY_GET_PRIVATE_CONFIG_DATA
          : QUERY_GET_PUBLIC_CONFIG_DATA;

        const newState = await graphQlClient(query, { id: action.id });

        return newState;
      }

      case SET_CONFIG_DATA: {
        const newState = await graphQlClient(MUTATION_SET_CONFIG_DATA, {
          input: action.payload,
        });

        return newState;
      }

      default: {
        return state;
      }
    }
  } catch (err) {
    handleCatchReducer("configData", err);
    return configDataInitState;
  }
};
